import React, { useState, useEffect } from "react";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import ReportProblemIcon from "@mui/icons-material/ReportProblemRounded";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import { useNavigate } from "react-router-dom";
import {
  newLotteryInvoice,
} from "../features/lotteryInvoice";
import { useDispatch, useSelector } from "react-redux";
import {
  SocketResultHuay,
  getResultBuyHuay,
  resetResultHuay,
  disconnectHuayYak,
} from "../features/lotteryInvoice";
import PreviousBar from "../component/PreviousBar";
import numToFixed from "../helper/numToFixed";
import Countdown from "react-countdown";
import { removeLotteryHoldNumber, getDetailLotteryHoldNumber ,getTotalbetCacheJackpot, getDetailLotteryRound } from "../features/lotteryInvoice"
import Moment from 'moment';
import 'moment/locale/th';

const Completionist = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch(); 
  useEffect(() => {
    navigate("/buylottery");
  }, []);
  const listNumber = JSON.parse(localStorage.getItem(localStorage.getItem("lotteryId"))).map(data => {
    return data.lotteryNumber
  })
  localStorage.setItem(localStorage.getItem("lotteryId"), JSON.stringify([]));
  localStorage.setItem(
    `check_${localStorage.getItem("lotteryId")}`,
    JSON.stringify([])
  );
  // dispatch(removeLotteryHoldNumber(listNumber))
  return alert("หมดเวลาในการซื้อกรุณาทำรายการใหม่");
};

const renderer = (props) => {
  console.log("props.completed :", props.completed)
  if (props.completed) {
    return <Completionist />;
  } else {
    return (
      <span>
        {props.hours}:{props.minutes}:{props.seconds}
      </span>
    );
  }
};

const Header = (props) => {
  console.log("props.detailLotteryRoundDate :", props.detailLotteryRoundDate)
  switch (props.process) {
    case 0:
      return (
        <>
          <p className="tet-lg">งวดวันที่ {Moment(props.detailLotteryRoundDate).locale("th").format('Do MMMM YYYY')}</p>
          {/* <p className="text-sm">ตะกร้าสินค้า</p> */}

          <div className="text-lg my-2">
            <p className="">กรุณาชำระเงิน</p>
            <p className="text-red-500 text-xl">
              <Countdown date={JSON.parse(Date.now() + props.lastTimer)} renderer={renderer} /> วินาที
            </p>
          </div>
        </>
      );
    case 1:
      return (
        <>
          <p>ตรวจสอบก่อนยืนยันการสั่งซื้อ</p>
          <div className="bg-green-200 py-1">
            <p className="text-[#b3853e]">งวดวันที่ {Moment(props.detailLotteryRoundDate).locale("th").format('Do MMMM YYYY')}</p>
            <p className="text-red-500">
              <ReportProblemIcon fontSize="small" />
              กรุณาตรวจสอบข้อมูลทั้งหมดก่อนการยืนยัน
            </p>
            <p className="text-red-500 text-xl"><Countdown date={Date.now() + props.lastTimer} renderer={renderer}/> นาที</p>
          </div>
        </>
      );
    case 2:
      return (
        <>
          <p>ตรวจสอบก่อนยืนยันการสั่งซื้อ</p>
          <div className="bg-green-200 py-1">
            <p className="text-[#b3853e]">งวดวันที่ {Moment(props.detailLotteryRoundDate).locale("th").format('Do MMMM YYYY')}</p>
            <p className="text-[#b3853e]">
              <CheckCircleOutlineRoundedIcon fontSize="small" />
              สั่งซื้อสำเร็จ Ref: {props.resultHuay?.data.refCode}
            </p>
            <p className="text-xs text-[#b3853e]">
              ซื้อเมื่อเวลา{" "}
              {new Date(props.resultHuay?.data.invoiceDatetime).toLocaleString(
                "th-TH"
              )}
            </p>
          </div>
        </>
      );
    default:
      return <></>;
  }
};

const Footer = (props) => {
  // console.log(props.disable)
  switch (props.process) {
    case 0:
      return (
        <>
          <button
            className="w-full rounded-full py-1 bg-[#b3853e] text-[#f8eede]"
            onClick={() => props.navigate("/buylottery")}
          >
            ซื้อเพิ่ม
          </button>
          <button
            className="col-span-2 border-2 w-full rounded-full py-1 border-[#b3853e]"
            onClick={() => props.onClick()}
          >
            กดสั่งซื้อ
          </button>
        </>
      );
    case 1:
      return (
        <>
          <button
            className="col-span-3 border-2 w-full rounded-full py-1 border-[#b3853e]"
            onClick={() => props.onClick()}
            disabled={props.disable}
          >
            {props.disable ? `รอสักครู่` : `ยืนยันการสั่งซื้อ`}
          </button>
        </>
      );
    case 2:
      return (
        <>
          <button
            className="w-full rounded-full py-1 bg-[#b3853e] text-[#f8eede]"
            onClick={() => props.onClick("/historylottery")}
          >
            ดูโพย
          </button>
          <button
            className="col-span-2 border-2 w-full rounded-full py-1 border-[#b3853e]"
            onClick={() => props.onClick("/dashboard")}
          >
            กลับไปหน้าหลัก
          </button>
        </>
      );
    default:
      return <></>;
  }
};

const setSum = (listData) => {
  let result = 0;
  for (let i = 0; i < listData?.length; i++) {
    result += listData[i]?.betAmount;
  }
  return result;
};

const resultAmount = (listData, credit, process) => {
  let result = 0;
  for (let i = 0; i < listData?.length; i++) {
    result += listData[i]?.betAmount;
  }
  return process === 2
    ? numToFixed(Number(credit))
    : numToFixed(Number(credit) - result);
};

const deleteListLotteryPickup = async (indexData, setCountDelete, navigate, dispatch) => {
  let listPickupInStorage = JSON.parse(
    localStorage.getItem(localStorage.getItem("lotteryId"))
  );
  // console.log("[listPickupInStorage[indexData].lotteryNumber] :", [listPickupInStorage[indexData].lotteryNumber])
  await dispatch(removeLotteryHoldNumber([listPickupInStorage[indexData].lotteryNumber]))
  let listPickupInStorageCheck = JSON.parse(
    localStorage.getItem(`check_${localStorage.getItem("lotteryId")}`)
  );
  listPickupInStorage.splice(indexData, 1);
  listPickupInStorageCheck.splice(indexData, 1);
  localStorage.setItem(
    localStorage.getItem("lotteryId"),
    JSON.stringify(listPickupInStorage)
  );
  localStorage.setItem(
    `check_${localStorage.getItem("lotteryId")}`,
    JSON.stringify(listPickupInStorageCheck)
  );
  setCountDelete((prev) => prev + 1);
  if (!listPickupInStorage.length && !listPickupInStorageCheck.length) {
    localStorage.removeItem(`timer_${localStorage.getItem("lotteryId")}`)
    navigate("/buylottery");
  }
};

const clearListLotteryPickup = (setCountDelete) => {
  localStorage.setItem(localStorage.getItem("lotteryId"), JSON.stringify([]));
  localStorage.setItem(
    `check_${localStorage.getItem("lotteryId")}`,
    JSON.stringify([])
  );
  setCountDelete((prev) => prev + 1);
};

const ListLotteryPickup = ({
  indexData,
  lotteryNumber,
  count,
  betAmount,
  setCountDelete,
  navigate,
  process,
  dispatch,
  memberSetting,
  totalbetcache
}) => {
  // console.log("totalbetcachetotalbetcache :", totalbetcache)
  // console.log("memberSettingmemberSetting :", memberSetting)
  return (
    <tr className="odd:bg-slate-300 even:bg-[#f8eede]">
      <td className="py-1">{lotteryNumber}</td>
      <td>{count}</td>
      <td>{(totalbetcache && totalbetcache[lotteryNumber] < memberSetting) ? betAmount : "เลขนี้ถูกซื้อไปแล้ว" }</td>
      {process === 2 ? (
        <td></td>
      ) : (
        <td>
          <DeleteForeverIcon
            onClick={() =>
              deleteListLotteryPickup(indexData, setCountDelete, navigate, dispatch)
            }
          />
        </td>
      )}
    </tr>
  );
};

const checkCanBuy = (memberSetting, totalbetcache) => {
  const listNumber = JSON.parse(localStorage.getItem(localStorage.getItem("lotteryId")))
  // const result = listNumber.map(data => {
  //   console.log("data :", data)
  //   console.log("memberSetting :", memberSetting)
  //   console.log("totalbetcache :", totalbetcache[data.lotteryNumber])
  //   if((totalbetcache[data.lotteryNumber] < memberSetting)) {
  //     return false
  //   }
  // })

  const result = listNumber.filter(data => (totalbetcache[data.lotteryNumber] >= memberSetting))

  if(result.length > 0) {
    return false
  }
  return true
}

const Checkout = () => {
  const [process, setProcess] = React.useState(0);
  const [listPickup, setList] = React.useState([]);
  const [countDelete, setCountDelete] = React.useState(0);
  const [Count, setCount] = React.useState(0);
  const resultHuay = useSelector((state) => state.invoice.resultBuy);
  const credit = useSelector((state) => state.credit.credit);
  const lastTimer = useSelector((state) => state.invoice.lastTimer);
  const memberSetting = useSelector((state) => state.invoice.memberSetting);
  const totalbetcache = useSelector((state) => state.invoice.totalbetcache);
  const detailLotteryRoundDate = useSelector((state) => state.invoice.detailLotteryRoundDate);
  const [invoiceRemark, setInvoiceRemark] = useState("");
  // console.log(resultHuay);
  const [CloseButton, setCloseButton] = React.useState(false);
  const [room, setRoom] = React.useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

  React.useEffect(() => {
    dispatch(getDetailLotteryHoldNumber())
    dispatch(getTotalbetCacheJackpot())
    // console.log("lastTimer :", lastTimer)
    dispatch(getTotalbetCacheJackpot())
    // console.log("memberSetting :", memberSetting)
    // console.log("totalbetcache :", totalbetcache)
    dispatch(getDetailLotteryRound())
  },[])

  React.useEffect(() => {
    setList(
      JSON.parse(localStorage.getItem(localStorage.getItem("lotteryId")))
    );
    
    // dispatch(getDetailLotteryHoldNumber())
    // console.log("lastTimer :", lastTimer)
    // localStorage.setItem(`timer_${localStorage.getItem("lotteryId")}`, JSON.parse(Date.now() + lastTimer))

    if (!room) {
      disconnectHuayYak();
      SocketResultHuay();
      dispatch(getResultBuyHuay());
      setRoom(true);
    }

    const countdown = async () => {
      if (Count > 0 && Count <= 7) {
        if (resultHuay) {
          // console.log(resultHuay);
          if (resultHuay.code == "0") {
            setProcess((prev) => prev + 1);
          } else {
            alert(resultHuay.message);
            dispatch(resetResultHuay());
          }
          setCount(0);
          setCloseButton(false);
        } else {
          await sleep(1000);
          await setCount((prev) => prev + 1);
        }
      }
      if (Count > 7) {
        alert("การส่งโพยขัดข้อง กรุณารอสักครู่แล้วเชคที่หน้าดูโพยนะคะ");
        dispatch(resetResultHuay());
        setCloseButton(false);
        setCount(0);
      }
    };

    countdown();
  }, [countDelete, Count]);

  const onClick = async (goto) => {
    switch (process) {
      case 0:
        if(!checkCanBuy(memberSetting, totalbetcache)) {
          alert("มีเลขที่ถูกซื้อไปแล้วกรุณ่ตรวจสอบใหม่");
        }else{
          setProcess((prev) => prev + 1);
        }
        break;
      case 1:
        setCloseButton(true)
        const res = await newLotteryInvoice(
          listPickup,
          setSum(listPickup),
          invoiceRemark
        );
        if (res.code == "999999") {
          setCount((prev) => prev + 1);
        } else {
          alert(res.message);
          dispatch(resetResultHuay());
          setCloseButton(false)
        }
        break;
      case 2:
        setProcess(0);
        dispatch(resetResultHuay());
        clearListLotteryPickup(setCountDelete);
        navigate(goto);
        break;
      default:
        break;
    }
  };

  return (
    <>
      <PreviousBar name="ชำระเงิน" />
      <div className="md:mx-10 w-auto rounded-lg border border-[#b3853e] my-5 py-2 text-center text-[#b3853e] px-1 md:px-10 font-bold">
        <Header process={process} resultHuay={resultHuay} navigate={navigate} lastTimer={lastTimer} detailLotteryRoundDate={detailLotteryRoundDate}/>
        <h5 className="text-start text-sm mt-1">รายการสั่งซื้อ</h5>
        <div className="overflow-y-auto h-[400px] xs:h-[400px] md:h-[600px] w-full scrollbar">
          <table className="w-full table-fixed border-collapse my-2 text-sm">
            <thead>
              <tr className="border-t border-b border-[#b3853e]">
                <th className="py-1">หมายเลข</th>
                <th>จำนวน</th>
                <th>ราคา</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {listPickup?.length != 0 ? (
                listPickup?.map((data, i) => {
                  return (
                    <ListLotteryPickup
                      key={i}
                      indexData={i}
                      lotteryNumber={data.lotteryNumber}
                      count={1}
                      betAmount={data.betAmount}
                      setCountDelete={setCountDelete}
                      navigate={navigate}
                      process={process}
                      dispatch={dispatch}
                      memberSetting={memberSetting}
                      totalbetcache={totalbetcache}
                    />
                  );
                })
              ) : (
                <></>
              )}
            </tbody>
          </table>
        </div>
        <div className="bg-green-500 grid grid-cols-3 gap-1 px-1 text-base py-1 text-center font-bold text-white-500">
                <div className="py-4 text-black">บันทึกโพย :</div>
                <textarea
                  className="col-span-2 border rounded w-full py-1 px-5 focus:outline-none focus:ring-2 focus:ring-defaultColor"
                  rows="2"
                  cols="50"
                  onChange={(e) => setInvoiceRemark(e.target.value)}
                  value={invoiceRemark}
                  placeholder=""
                  disabled={process == 0 ? false : true}
                ></textarea>
              </div>

        <div className="flex justify-around bg-[#b3853e] text-[#f8eede] py-0.5">
          <div>
            <p className="text-sm">ยอดซื้อทั้งหมด:</p>
            <p>{setSum(listPickup)} THB</p>
          </div>
          <div>
            <p className="text-sm">ยอดเงินคงเหลือ:</p>
            <p>{resultAmount(listPickup, credit, process)} THB</p>
          </div>
        </div>
        <div className="grid grid-cols-3 gap-2 place-items-center my-2">
          <Footer
            process={process}
            onClick={onClick}
            navigate={navigate}
            disable={CloseButton}
          />
        </div>
      </div>
    </>
  );
};

export default Checkout;
